var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#32B1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5199 7.20642C12.2367 6.93119 11.7633 6.93119 11.4801 7.20642L7.20057 11.3655C6.7635 11.7902 7.08774 12.4943 7.72044 12.4943L7.87014 12.4943V15.6648C7.87014 16.4022 8.51396 17 9.30815 17H10.6237C10.6234 16.9921 10.6233 16.9841 10.6233 16.9761V14.4492C10.6233 14.0805 10.9452 13.7816 11.3423 13.7816H12.6575C13.0546 13.7816 13.3765 14.0805 13.3765 14.4492V16.9761C13.3765 16.9841 13.3764 16.9921 13.3761 17H14.6918C15.486 17 16.1299 16.4022 16.1299 15.6648V12.4943L16.2796 12.4943C16.9123 12.4943 17.2365 11.7902 16.7994 11.3655L12.5199 7.20642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLocation);
export default __webpack_public_path__ + "static/media/home-location.48956298a85f5e68113382440f162a74.svg";
export { ForwardRef as ReactComponent };